/**
 * Device-type detection for the FIELD-ONLY kiosk + face-enrolment screens.
 *
 * No single signal is reliable: User-Agent is spoofable and iPadOS 13+ reports
 * as "Macintosh" in Safari. We therefore combine touch + pointer signals, which
 * together catch almost all real phones/tablets while excluding desktops/laptops.
 */

const MOBILE_UA = /Android|iPhone|iPad|iPod|Windows Phone|Silk|Kindle|BlackBerry|Opera Mini|Mobile/i;

/** Touch hardware present. Desktops report 0; modern phones/tablets (incl. iPad
 * on iOS 13+, which lacks a mobile UA) report >= 1 — the most reliable signal. */
export const hasTouch = () => (navigator.maxTouchPoints || 0) >= 1;

/** Primary pointer is coarse (finger), not a mouse. True on touch-primary devices. */
export const isCoarsePointer = () => {
  try {
    return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  } catch {
    return false;
  }
};

export const matchesMobileUA = () => MOBILE_UA.test(navigator.userAgent || '');

/**
 * True for phones and tablets. Requires BOTH a touch device AND a coarse primary
 * pointer — belt-and-suspenders, since either alone is spoofable and a touchscreen
 * laptop (touch + mouse) resolves its primary pointer to 'fine' → desktop.
 */
export const isMobileOrTablet = () => hasTouch() && isCoarsePointer();

/** "mobile" | "tablet" | "desktop" from screen width + touch signals. */
export const deviceCategory = () => {
  if (!isMobileOrTablet()) return 'desktop';
  const w = (window.screen && window.screen.width) || window.innerWidth || 0;
  return w >= 600 ? 'tablet' : 'mobile';
};
